// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PriceDetailItem_wrapper__zUqjn","value":"PriceDetailItem_value__tmabj","divider":"PriceDetailItem_divider__3GPxA"};